import * as Api from 'redux/api/Applications/Datasets/v3'
import * as Types from 'redux/actions/Applications/types'

import { toggleSnackbarOpen } from '../../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

export function tryCreateDataset(attributes, onSuccess) {
  return (dispatch) => {
    dispatch({
      type: Types.CREATE_APPS_DATASET
    })

    const body = {
      data: {
        attributes
      }
    }

    Api.create(body)
      .then((response) => {
        dispatch({
          type: Types.CREATE_APPS_DATASET_SUCCESS,
          payload: {
            ...response.data.data,
            data_product_id: attributes.data_product_id
          }
        })

        onSuccess()

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.CREATE_APPS_DATASET_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryUpdateDataset(id, attributes, onSuccess) {
  return (dispatch) => {
    dispatch({
      type: Types.UPDATE_APPS_DATASET
    })

    const body = {
      data: {
        attributes
      }
    }

    Api.update(id, body)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_APPS_DATASET_SUCCESS,
          payload: {
            ...response.data.data,
            data_product_id: attributes.data_product_id
          }
        })

        onSuccess()

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.UPDATE_APPS_DATASET_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryDeleteDataset(id, dataProductId) {
  return (dispatch) => {
    dispatch({
      type: Types.DELETE_APPS_DATASET
    })

    Api.destroy(id)
      .then(() => {
        dispatch({
          type: Types.DELETE_APPS_DATASET_SUCCESS,
          payload: { id, data_product_id: dataProductId }
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.DELETE_APPS_DATASET_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryGetDatasetPreview(endpoint, query) {
  return (dispatch) => {
    dispatch({
      type: Types.GET_APPS_DATASET_PREVIEW
    })

    Api.getPreview(endpoint, query)
      .then((response) => {
        const key = `${endpoint}${query}`

        dispatch({
          type: Types.GET_APPS_DATASET_PREVIEW_SUCCESS,
          payload: { key, data: response.data, endpoint }
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_APPS_DATASET_PREVIEW_FAILED
        })
      })
  }
}

export function tryPutTableFilterVariables(id, body) {
  return (dispatch) => {
    dispatch({
      type: Types.PUT_TABLE_FILTER_VARIABLES
    })

    Api.putTableFilterVariables(id, body)
      .then((response) => {
        dispatch({
          type: Types.PUT_TABLE_FILTER_VARIABLES_SUCCESS,
          payload: { id, data: response.data.data }
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.PUT_TABLE_FILTER_VARIABLES_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryExportDataset(id, dataProductName, query) {
  return (dispatch) => {
    dispatch({
      type: Types.EXPORT_INSIGHT_STUDIO
    })

    Api.exportDataset(id, query)
      .then((response) => {
        const fileName = `${dataProductName}.xlsx`
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        )
        const link = document.createElement('a')

        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()

        dispatch({
          type: Types.EXPORT_INSIGHT_STUDIO_SUCCESS
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.EXPORT_INSIGHT_STUDIO_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryGetDatasetTransformation(id) {
  return (dispatch) => {
    dispatch({
      type: Types.GET_DATASET_TRANSFORMATION
    })

    Api.getTransformation(id)
      .then((response) => {
        dispatch({
          type: Types.GET_DATASET_TRANSFORMATION_SUCCESS,
          payload: { id, data: response.data.data }
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_DATASET_TRANSFORMATION_FAILED
        })
      })
  }
}

export function tryGetDatasetFilterVariables(id) {
  return (dispatch) => {
    dispatch({
      type: Types.GET_DATASET_FILTER_VARIABLES
    })

    Api.getFilterVariables(id)
      .then((response) => {
        dispatch({
          type: Types.GET_DATASET_FILTER_VARIABLES_SUCCESS,
          payload: { id, data: response.data.data }
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_DATASET_FILTER_VARIABLES_FAILED
        })
      })
  }
}
